const Images = {
	Logo: '/images/logo.png',
	Technology: {
		LARAVEL: '/images/laravel.png',
		REACT: '/images/react.png',
	},
};

export default Images;
